import request from 'superagent';

const xhrHeaders = {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
};

const loadDataAction = (ctx, { url }, done) => {
    request
        .get(url)
        .set(xhrHeaders)
        .end((err, res) => {
            if (err) {
                // TODO?
            } else {
                ctx.dispatch('FAVORITE_DATA_LOADED', res.body);
            }
            done();
        });
};

const favoriteAction = (ctx, { url, csrfToken }, done) => {
    ctx.dispatch('FAVORITE_START');
    request
        .put(url)
        .set(xhrHeaders)
        .set('X-CSRF-Token', csrfToken)
        .end((err) => {
            if (err) {
                ctx.dispatch('FAVORITE_FAIL');
            } else {
                ctx.dispatch('FAVORITE_SUCCESS');
            }
            done();
        });
};

const unfavoriteAction = (ctx, { url, csrfToken }, done) => {
    ctx.dispatch('UNFAVORITE_START');
    request
        .delete(url)
        .set(xhrHeaders)
        .set('X-CSRF-Token', csrfToken)
        .end((err) => {
            if (err) {
                ctx.dispatch('UNFAVORITE_FAIL');
            } else {
                ctx.dispatch('UNFAVORITE_SUCCESS');
            }
            done();
        });
};

export {
    loadDataAction,
    favoriteAction,
    unfavoriteAction,
};



// WEBPACK FOOTER //
// ./src/js/apps/favorite-designer/actions.js